export default __webpack_public_path__ + "static/Open_Graph-27057e4df61373e86a0332e3babcd8fb.png";